import roomac from "../assets/images/roomac.svg";
import roomairpurifier from "../assets/images/roomairpurifier.svg";
import roombalcony from "../assets/images/roombalcony.svg";
import roombathtub from "../assets/images/roombathtub.svg";
import roombed from "../assets/images/roombed.svg";
import roomcouplefriendly from "../assets/images/roomcouplefriendly.svg";
import roomdining from "../assets/images/roomdining.svg";
import roomheater from "../assets/images/roomheater.svg";
import roomkettle from "../assets/images/roomkettle.svg";
import roomminibar from "../assets/images/roomminibar.svg";
import roomshower from "../assets/images/roomshower.svg";
import roomsmoking from "../assets/images/roomsmoking.svg";
import roomtv from "../assets/images/roomtv.svg";

export const RoomAmenityIcons = {
  AC: (
    <img
      loading="lazy"
      width={"20px"}
      height={"20px"}
      src={roomac}
      alt="roomac"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  Shower: (
    <img
      loading="lazy"
      width={"20px"}
      height={"20px"}
      src={roomshower}
      alt="roomshower"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  Smoking: (
    <img
      loading="lazy"
      width={"20px"}
      height={"20px"}
      src={roomsmoking}
      alt="roomsmoking"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  TV: (
    <img
      loading="lazy"
      width={"20px"}
      height={"20px"}
      src={roomtv}
      alt="roomtv"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  "Bath Tub": (
    <img
      loading="lazy"
      width={"20px"}
      height={"20px"}
      src={roombathtub}
      alt="roombathtub"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  "Air purifier": (
    <img
      loading="lazy"
      width={"20px"}
      height={"20px"}
      src={roomairpurifier}
      alt="roomairpurifier"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  "Electric Kettle": (
    <img
      loading="lazy"
      width={"20px"}
      height={"20px"}
      src={roomkettle}
      alt="roomkettle"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  "In room Dining": (
    <img
      loading="lazy"
      width={"20px"}
      height={"20px"}
      src={roomdining}
      alt="roomdining"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  Minibar: (
    <img
      loading="lazy"
      width={"20px"}
      height={"20px"}
      src={roomminibar}
      alt="roomminibar"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  Heater: (
    <img
      loading="lazy"
      width={"20px"}
      height={"20px"}
      src={roomheater}
      alt="roomheater"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  "King Size": (
    <img
      loading="lazy"
      width={"20px"}
      height={"20px"}
      src={roombed}
      alt="roombed"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  "Queen Size": (
    <img
      loading="lazy"
      width={"20px"}
      height={"20px"}
      src={roombed}
      alt="roombed"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  Balcony: (
    <img
      loading="lazy"
      width={"20px"}
      height={"20px"}
      src={roombalcony}
      alt="roombalcony"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  "Bunk Beds": (
    <img
      loading="lazy"
      width={"20px"}
      height={"20px"}
      src={roombed}
      alt="roombed"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  "Twin Beds": (
    <img
      loading="lazy"
      width={"20px"}
      height={"20px"}
      src={
        "https://ik.imagekit.io/hotelzifyprod/New%20Amenity/Property%201=Bed_BhaypuAW0w.png?updatedAt=1692803295593"
      }
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(351deg) brightness(93%) contrast(86%)",
      }}
      alt="roomsmoking"
    />
  ),
  "Full bed": (
    <img
      loading="lazy"
      width={"20px"}
      height={"20px"}
      src={
        "https://ik.imagekit.io/hotelzifyprod/New%20Amenity/Property%201=Bed_BhaypuAW0w.png?updatedAt=1692803295593"
      }
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(351deg) brightness(93%) contrast(86%)",
      }}
      alt="roomsmoking"
    />
  ),
  "Couple Friendly": (
    <img
      loading="lazy"
      width={"20px"}
      height={"20px"}
      src={roomcouplefriendly}
      alt="roomcouplefriendly"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  Fridge: (
    <img
      loading="lazy"
      width={"20px"}
      height={"20px"}
      src={"https://ik.imagekit.io/hotelzifyprod/fridge.svg"}
      alt="fridge"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  "Hair Dryer": (
    <img
      loading="lazy"
      width={"20px"}
      height={"20px"}
      src={"https://ik.imagekit.io/hotelzifyprod/hair%20dryer.svg"}
      alt="Hair Dryer"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  Microwave: (
    <img
      loading="lazy"
      width={"20px"}
      height={"20px"}
      src={"https://ik.imagekit.io/hotelzifyprod/microwave.svg"}
      alt="Microwave"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  Iron: (
    <img
      loading="lazy"
      width={"20px"}
      height={"20px"}
      src={"https://ik.imagekit.io/hotelzifyprod/iron.svg"}
      alt="Iron"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  "Ironing Board": (
    <img
      loading="lazy"
      width={"20px"}
      height={"20px"}
      src={"https://ik.imagekit.io/hotelzifyprod/iron_board.svg"}
      alt="Ironing Board"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  "Adults Only": (
    <img
      loading="lazy"
      width="20"
      height="20"
      src="https://ik.imagekit.io/hotelzifyprod/adults-only_bc85b825-41a7-48ec-ab88-a0fae9eb6e28.jpeg?tr=w-20,h-20"
      alt="adults only"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  Beach: (
    <img
      loading="lazy"
      width="20"
      height="20"
      src="https://ik.imagekit.io/hotelzifyprod/beach_18848929_f6811547-7c28-4ef1-9ae9-246b2f6d123a.png?tr=w-20,h-20"
      alt="beach"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  Bike: (
    <img
      loading="lazy"
      width="20"
      height="20"
      src="https://ik.imagekit.io/hotelzifyprod/bicycle_1749821_bbfdbf01-0fea-44f1-a76c-f700c35802ae.png?tr=w-20,h-20"
      alt="bike"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  "Breakfast Included": (
    <img
      loading="lazy"
      width="20"
      height="20"
      src="https://ik.imagekit.io/hotelzifyprod/food_1938663_7db78e9f-eae9-4d09-bd74-b3f6f7ff99ff.png?tr=w-20,h-20"
      alt="breakfast included"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  "Children Activities": (
    <img
      loading="lazy"
      width="20"
      height="20"
      src="https://ik.imagekit.io/hotelzifyprod/playground_a2923b6d-42da-451b-a0ee-262ae0c66103.png?tr=w-20,h-20"
      alt="children activities"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  "Dog Bed": (
    <img
      loading="lazy"
      width="20"
      height="20"
      src="https://ik.imagekit.io/hotelzifyprod/pet-bed_0206ec78-d1b0-437e-b312-2ad0ca76f217.png?tr=w-20,h-20"
      alt="dog bed"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  "Business Center": (
    <img
      loading="lazy"
      width="20"
      height="20"
      src="https://ik.imagekit.io/hotelzifyprod/meeting_e478ba0a-6a30-4780-9274-d47be0350ca5.png?tr=w-20,h-20"
      alt="business center"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  "Rollaway Bed": (
    <img
      loading="lazy"
      width="20"
      height="20"
      src="https://ik.imagekit.io/hotelzifyprod/furniture_d6c7452a-045c-43cf-a08b-22cdd464cc4b.png?tr=w-20,h-20"
      alt="rollaway bed"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  "Personalised Welcome Amenities": (
    <img
      loading="lazy"
      width="20"
      height="20"
      src="https://ik.imagekit.io/hotelzifyprod/welcome-drink_f0f00a87-1e40-4356-b346-15df24658c91.png?tr=w-20,h-20"
      alt="welcome amenities"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  "Pillow Menu": (
    <img
      loading="lazy"
      width="20"
      height="20"
      src="https://ik.imagekit.io/hotelzifyprod/pillow_4fc57837-2c5f-43a3-8599-d44d11da0c8e.png?tr=w-20,h-20"
      alt="pillow menu"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  Kitchenette: (
    <img
      loading="lazy"
      width="20"
      height="20"
      src="https://ik.imagekit.io/hotelzifyprod/cooking_43f4496e-1f89-42ea-823b-a72260391328.png?tr=w-20,h-20"
      alt="kitchenette"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  Crib: (
    <img
      loading="lazy"
      width="20"
      height="20"
      src="https://ik.imagekit.io/hotelzifyprod/crib-toy_6cc092cf-8b28-47df-af3c-b49d5cf7b788.png?tr=w-20,h-20"
      alt="crib"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  "Tea/Coffee Kit and Maker": (
    <img
      loading="lazy"
      width="20"
      height="20"
      src="https://ik.imagekit.io/hotelzifyprod/kitchen_d85a717a-1d95-4491-adff-2a7348e67296.png?tr=w-20,h-20"
      alt="tea coffee kit"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  "Ceiling Fans": (
    <img
      loading="lazy"
      width="20"
      height="20"
      src="https://ik.imagekit.io/hotelzifyprod/ceiling-fan_97ef8d04-56d9-44b1-8585-cfba6bfc94d3.png?tr=w-20,h-20"
      alt="ceiling fan"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  "Bathrobe & Slippers": (
    <img
      loading="lazy"
      width="20"
      height="20"
      src="https://ik.imagekit.io/hotelzifyprod/bathrobe_063fbe86-da9e-41a1-ac77-55e8fa95d223.png?tr=w-20,h-20"
      alt="bathrobe and slippers"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  Toiletries: (
    <img
      loading="lazy"
      width="20"
      height="20"
      src="https://ik.imagekit.io/hotelzifyprod/toiletries_3245124f-eeef-4d92-9a60-2939296cdabf.png?tr=w-20,h-20"
      alt="toiletries"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  "Room Safe": (
    <img
      loading="lazy"
      width="20"
      height="20"
      src="https://ik.imagekit.io/hotelzifyprod/safe_b5b03c66-70b4-4578-a8a3-008b59f40326.png?tr=w-20,h-20"
      alt="room safe"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  "Turndown Service": (
    <img
      loading="lazy"
      width="20"
      height="20"
      src="https://ik.imagekit.io/hotelzifyprod/service_9a0aa1b0-54c5-4d92-9795-f28c6b56b2d9.png?tr=w-20,h-20"
      alt="turndown service"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  Yoga: (
    <img
      loading="lazy"
      width="20"
      height="20"
      src="https://ik.imagekit.io/hotelzifyprod/yoga-pose_1a2f251e-c016-41d3-9311-71de341e7c69.png?tr=w-20,h-20"
      alt="yoga"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  "Wedding Services": (
    <img
      loading="lazy"
      width="20"
      height="20"
      src="https://ik.imagekit.io/hotelzifyprod/rings_d3ac5c7b-0816-4549-bab0-e3f1047cb9a3.png?tr=w-20,h-20"
      alt="wedding services"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  Vegan: (
    <img
      loading="lazy"
      width="20"
      height="20"
      src="https://ik.imagekit.io/hotelzifyprod/vegan_0fcc3471-ebdd-4bd8-87be-1bc57d8a03ae.png?tr=w-20,h-20"
      alt="vegan"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  Vegetarian: (
    <img
      loading="lazy"
      width="20"
      height="20"
      src="https://ik.imagekit.io/hotelzifyprod/vegetable_b878f3fd-6ff4-4e51-8a1b-5cec36c9184a.png?tr=w-20,h-20"
      alt="vegetarian"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  "Relax Area": (
    <img
      loading="lazy"
      width="20"
      height="20"
      src="https://ik.imagekit.io/hotelzifyprod/beach-chair_e484559f-e528-45df-8616-3b400b8b3f61.png?tr=w-20,h-20"
      alt="relax area"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  "Tennis Court": (
    <img
      loading="lazy"
      width="20"
      height="20"
      src="https://ik.imagekit.io/hotelzifyprod/tennis_4aa01f2e-9b7d-4dcd-b6ce-d6056ca3a14b.png?tr=w-20,h-20"
      alt="tennis court"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  "No Wifi": (
    <img
      loading="lazy"
      width="20"
      height="20"
      src="https://ik.imagekit.io/hotelzifyprod/no-signal_a8beb414-531a-4608-96f0-65d9c1970f9d.png?tr=w-20,h-20"
      alt="no wifi"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  "Botanical Garden": (
    <img
      loading="lazy"
      width="20"
      height="20"
      src="https://ik.imagekit.io/hotelzifyprod/greenhouse_26ca1c83-162b-4735-b5df-859262e7d735.png?tr=w-20,h-20"
      alt="botanical garden"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  "Private Jacuzzi": (
    <img
      loading="lazy"
      width="20"
      height="20"
      src="https://ik.imagekit.io/hotelzifyprod/jacuzzi_45e88cd3-e2a7-4e30-8eab-aab145d9a673.png?tr=w-20,h-20"
      alt="private jacuzzi"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  "Private Pool": (
    <img
      loading="lazy"
      width="20"
      height="20"
      src="https://ik.imagekit.io/hotelzifyprod/swimming-pool_3d3382c6-37b1-43cb-912c-e3fc4021d550.png?tr=w-20,h-20"
      alt="private pool"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  Parking: (
    <img
      loading="lazy"
      width="20"
      height="20"
      src="https://ik.imagekit.io/hotelzifyprod/parking_0c3dcebe-9d53-4a37-ac85-5f8f0567a43c.png?tr=w-20,h-20"
      alt="parking"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  "Hiking Trails": (
    <img
      loading="lazy"
      width="20"
      height="20"
      src="https://ik.imagekit.io/hotelzifyprod/hiking_a8ca6cf0-eb9e-417a-b877-932ccbba8878.png?tr=w-20,h-20"
      alt="hiking trails"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  "Jungle Trails": (
    <img
      loading="lazy"
      width="20"
      height="20"
      src="https://ik.imagekit.io/hotelzifyprod/travelling_f2a1e7a8-95f0-4b3a-b961-8a5e93cc8eb1.png?tr=w-20,h-20"
      alt="jungle trails"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  "No Smoking": (
    <img
      loading="lazy"
      width="20"
      height="20"
      src="https://ik.imagekit.io/hotelzifyprod/location_a0c43be9-8add-417a-b3f5-ddf8bd83a760.png?tr=w-20,h-20"
      alt="no smoking"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  "Laundry Services": (
    <img
      loading="lazy"
      width="20"
      height="20"
      src="https://ik.imagekit.io/hotelzifyprod/machine_17a1ea61-ec01-4fa2-9155-a4364c2f2827.png?tr=w-20,h-20"
      alt="laundry services"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  "Honeymoon / Romantic": (
    <img
      loading="lazy"
      width="20"
      height="20"
      src="https://ik.imagekit.io/hotelzifyprod/honeymoon_d53a3417-552b-47ec-8b79-b45d0ca5e10c.png?tr=w-20,h-20"
      alt="honeymoon romantic"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  "Golf Course": (
    <img
      loading="lazy"
      width="20"
      height="20"
      src="https://ik.imagekit.io/hotelzifyprod/golf_44acc95c-288d-424e-8f2d-ea670f687c4e.png?tr=w-20,h-20"
      alt="golf course"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  "Gift Shop": (
    <img
      loading="lazy"
      width="20"
      height="20"
      src="https://ik.imagekit.io/hotelzifyprod/gift-shop_d480d0f1-98cc-4b98-b696-347fdfb6d294.png?tr=w-20,h-20"
      alt="gift shop"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  "Fitness Center": (
    <img
      loading="lazy"
      width="20"
      height="20"
      src="https://ik.imagekit.io/hotelzifyprod/center_e72c8766-8560-43db-af3d-91b89a213332.png?tr=w-20,h-20"
      alt="fitness center"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  "Family Hotel": (
    <img
      loading="lazy"
      width="20"
      height="20"
      src="https://ik.imagekit.io/hotelzifyprod/family_c4e834cb-e3b4-4a9b-91ab-0706ee096cf9.png?tr=w-20,h-20"
      alt="family hotel"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  Concierge: (
    <img
      loading="lazy"
      width="20"
      height="20"
      src="https://ik.imagekit.io/hotelzifyprod/bell_bfcbe54c-a28d-49a3-bd41-6c45ad6204f9.png?tr=w-20,h-20"
      alt="concierge"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
  "Butler Service": (
    <img
      loading="lazy"
      width="20"
      height="20"
      src="https://ik.imagekit.io/hotelzifyprod/waiter_65c267c0-cee5-4e1a-b597-e4cf5cce0d83.png?tr=w-20,h-20"
      alt="butler service"
      style={{
        filter:
          "invert(38%) sepia(37%) saturate(1618%) hue-rotate(754deg) brightness(73%) contrast(86%)",
      }}
    />
  ),
};
